import React, { useEffect, useState } from "react";

import { InputNumber, InputNumberChangeParams } from "primereact/inputnumber";
import { TimeSpan, secondsToTimeSpan, timeSpanToSeconds } from "utils/time-utils";

type TimeSpanInputsProps = {
  value: number
  onChange: (value: number) => void
}

type TimeSpanType = {
  name: TimeSpanName;
  short: string;
  value: number;
  max: number;
}

type TimeSpanName = "days" | "hours" | "minutes" | "seconds";

const TimeSpanInputs: React.FC<TimeSpanInputsProps> = ({value, onChange}) => {
  const { days, hours, minutes, seconds } = secondsToTimeSpan(value);
  const [timeSpan, setTimeSpan] = useState<TimeSpan>({ days, hours, minutes, seconds });

  useEffect(() => {
    onChange(timeSpanToSeconds(timeSpan));
  }, [timeSpan]);

  const timeSpans: TimeSpanType[] = [
    {
      name: "days",
      short: "d",
      value: timeSpan.days,
      max: 100,
    },
    {
      name: "hours",
      short: "h",
      value: timeSpan.hours,
      max: 23,
    },
    {
      name: "minutes",
      short: "m",
      value: timeSpan.minutes,
      max: 59,
    },
    {
      name: "seconds",
      short: "s",
      value: timeSpan.seconds,
      max: 59,
    },
  ];

  const handleChange = (name: TimeSpanName, number: number | null) => {
    if (number === null || typeof number !== "number" || number < 0) return;
    setTimeSpan(prev => ({ ...prev, [name]: number }));
  }

  return (
    <>
      {timeSpans.map(ts => (
        <TimeSpanInput key={ts.name} timespan={ts} onChange={e => handleChange(ts.name, e.value)}/>
      ))}
    </>
  );
};

type TimeSpanInputProps = {
  timespan: TimeSpanType
  onChange: (e: InputNumberChangeParams) => void
}

const TimeSpanInput: React.FC<TimeSpanInputProps> = ({timespan, onChange}) => {
  return (
    <>
      <InputNumber
            value={timespan.value}
            name={timespan.name}
            onChange={onChange}
            className="p-inputtext-sm"
            style={{ blockSize: "2.8rem" }}
            min={0}
            max={timespan.max}
          />
          <p className="p-inputgroup-addon" style={{ blockSize: "2.8rem", minWidth: "2rem" }}>
            {timespan.short}
          </p>
    </>
  );
}

export default TimeSpanInputs;
